/*
 * Purpose: Choose Gmail inbound mode — real inbox (OAuth) vs edge webhook inbox
 * Last modified: 2026-06-25 | Agent
 * Completeness: 95
 */

export type GmailInboundSource = 'gmail_api' | 'webhook';

export const DEFAULT_JOB_GMAIL_QUERY = 'from:linkedin.com subject:job newer_than:7d';

/** True when the outcome reads like the user's real Gmail, not a synthetic webhook inbox. */
export function prefersGmailApiForOutcome(...texts: string[]): boolean {
  const combined = texts.join(' ').toLowerCase();
  if (/\b(webhook|edge inbox|post url|forward.*json)\b/.test(combined)) return false;
  return /\b(gmail|email|inbox|job alert|receipt|emails? me|my mail|when i get|linkedin.*email)\b/.test(
    combined
  );
}

export function defaultGmailSourceForOutcome(rawOutcome: string, interpretedGoal = ''): GmailInboundSource {
  return prefersGmailApiForOutcome(rawOutcome, interpretedGoal) ? 'gmail_api' : 'webhook';
}
